import ga from './ga'

function init({ gaTrackingId, history }: any) {
  ga.init(gaTrackingId, history)
}

const analytics = { ga, init }

export default analytics
